// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"210":"vendor.footer-component","979":"vendor.web-vitals"}[chunkId] + "." + {"210":"5f7310e6","979":"ae691ae9"}[chunkId] + ".chunk.js";
};